import Vue from 'vue';
import VueResource from 'vue-resource';
import formatarData from '~js/formatar-data';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    return Vue.http.get('/api/SolicitacaoEventoRealizados', { params: parametros });
  },
  listaDeTurmas: async function () {
    return await Vue.http.get('/api/SolicitacaoEventoRealizados/turmas').then(response => response.data);
  },
  listagemExcel: filtros => {
    return Vue.http.get('/api/SolicitacaoEventoRealizados/Excel',
      {
        params: {
          idTurma: filtros.idTurma
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-evento-realizados/servico.js